import {createLayout} from '../util/struct_array';

export default createLayout([
    {name: 'a_pos3d', type: 'Int16', components: 3}
]);
